import React, {useEffect, useState} from 'react';
import Header from "../components/layout/Header";
import Wrapper from "../components/layout/Wrapper";
import Footer from "../components/layout/Footer";
import {Helmet} from "react-helmet-async";
import axios from "axios";
import {APP_API_BASE} from "../utils/apiConfig";
import SEO from "../components/layout/SEO";


const Rules = () => {
    const [rules, setRules] = useState([]);

    const { lang, t } = useLanguage();

    const fetchRules = async () => {

        try {

            const res = await axios.get(
                `${APP_API_BASE}/rules`,
                {
                    params: {
                        language: lang
                    }
                }
            );

            if (res.data.success) {
                setRules(res.data.content);
            }

        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchRules();
    }, []);


    return (
        <>
            <SEO
                title={t.seo.rules.title}
                description={t.seo.rules.description}
                path="/rules"
            />

            <div className='flex flex-col min-h-screen'>
                <Header/>
                <Wrapper className='flex-1 my-10'>
                    <div className='w-1/2 mx-auto relative'>
                        {
                            rules.length > 0 &&
                            rules.map((rule, index) => {
                                if (rule.type === "heading") {
                                    return (
                                        <h3
                                            key={index}
                                            className="text-lg font-bold text-gray-900 mt-6 mb-3"
                                        >
                                            {rule.text}
                                        </h3>
                                    );
                                }

                                return (
                                    <p
                                        key={index}
                                        className="text-gray-700 leading-8 mb-4 whitespace-pre-line"
                                    >
                                        {rule.text}
                                    </p>
                                );
                            })
                        }
                    </div>
                </Wrapper>
                <Footer/>
            </div>
        </>
    );
};

export default Rules;
